import { render } from "./SearchBar.vue?vue&type=template&id=3ad5936e"
import script from "./SearchBar.js?vue&type=script&lang=js"
export * from "./SearchBar.js?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__